import React, { Component } from "react";
import { connect } from "react-redux";
import { Layout } from "antd";
import appActions from "../../redux/app/actions";
import TopbarUser from "./topbarUser";
import TopbarWrapper from "./topbar.style";
import UserAccountMenu from "../../customApp/components/accounts/UserAccountMenu";
// import TopbarNotification from "./topbarNotification";

const { Header } = Layout;
const { toggleCollapsed } = appActions;

class Topbar extends Component {
    render() {
        const { toggleCollapsed, customizedTheme, locale } = this.props;
        const collapsed = this.props.collapsed && !this.props.openDrawer;
        const styling = {
            background: customizedTheme.backgroundColor,
            position: "fixed",
            width: "100%",
            height: 70
        };
        return (
            <TopbarWrapper>
                <Header
                    style={styling}
                    className={
                        collapsed ? "isomorphicTopbar collapsed" : "isomorphicTopbar"
                    }
                >
                    <div className="isoLeft">
                        <button
                            className={
                                collapsed ? "triggerBtn menuCollapsed" : "triggerBtn menuOpen"
                            }
                            style={{ color: customizedTheme.textColor }}
                            onClick={toggleCollapsed}
                        />
                    </div>

                    <ul className="isoRight" style={{paddingTop: "10px"}}>
                        {
                            <li className="isoSearch">
                                <UserAccountMenu />
                            </li>
                        }

                        {/* <li
                            onClick={() => this.setState({ selectedItem: "notification" })}
                            className="isoNotify"
                        >
                            <TopbarNotification locale={locale} />
                        </li>

                        <li
                            onClick={() => this.setState({ selectedItem: "message" })}
                            className="isoMsg"
                        >
                            <TopbarMessage locale={locale} />
                        </li>
                        <li
                            onClick={() => this.setState({ selectedItem: "addToCart" })}
                            className="isoCart"
                        >
                            <TopbarAddtoCart url={url} locale={locale} />
                        </li> */}

                        <li
                            onClick={() => this.setState({ selectedItem: "user" })}
                            className="isoUser"
                        >
                            <span className="isoUserName">{"Hello " + this.props.user?.name.replace(/\b\w/g, char => char.toUpperCase()) + "!"}</span>
                            <TopbarUser locale={locale} />
                        </li>
                    </ul>
                </Header>
            </TopbarWrapper>
        );
    }
}

export default connect(
    state => ({
        ...state.App,
        user: state.Auth.user,
        locale: state.LanguageSwitcher.language.locale,
        customizedTheme: state.ThemeSwitcher.topbarTheme
    }),
    { toggleCollapsed }
)(Topbar);
